/**
 * import topicsDir from "../__topicsDir";
*/

/**
 * events data
 * イベント一覧データ
 * @props {string} date 日時（YYYY-MM-DD\THH:mm）
 * @props {string} title タイトル（html）
 * @props {string} [href] リンクURL
 */
export default [
	{
		date: "2023-11-13T11:00",
		title: `
<h4>新潟県医師会在宅医療推進センターより</h4>
<p class="paragraph-indent">
●第15回在宅ケアを考える集いin越後2023を9月23日（土・祝）に開催いたしました。<br>
収録した映像をYouTubeにて公開しています。<br>
・<a href="https://youtu.be/jwPpDdyxusw">動画URL</a><br>
</p>
		`.trim().replace(/\t|\n/g, "")
	}
];
